export enum PscModalStep {
  FORM = 'form',
  REGISTERED = 'registered',
  SAVED = 'saved',
}